import { axiosInstance } from 'providers/axios.provider'
import { handleResponse } from 'providers'
import { api } from '@constants'

const getUserInformation = async (userToken: string) => {
  const response = await axiosInstance.get(
    `${api.userInformation}/${userToken}`
  )
  return handleResponse(response)
}

const getMyCourses = async (
  userId: number,
  page: number,
  rowsPerPage: number,
  search: string,
  orderBy: string,
  orderType: string
) => {
  const params = {
    page: page,
    per_page: rowsPerPage,
    search: search,
    'sorts[]': `${orderBy} ${orderType}`
  }
  const response = await axiosInstance.get(
    `${api.myCourses.replace('{userId}', userId.toString())}`,
    { params: params }
  )
  return handleResponse(response)
}

const getMyCertificates = async (
  userId: number,
  page: number,
  rowsPerPage: number,
  search: string,
  orderBy: string,
  orderType: string
) => {
  const params = {
    page: page,
    per_page: rowsPerPage,
    search: search,
    'sorts[]': `${orderBy} ${orderType}`
  }
  const response = await axiosInstance.get(
    `${api.myCertificates.replace('{userId}', userId.toString())}`,
    { params: params }
  )
  return handleResponse(response)
}

export const userProfileService = {
  getUserInformation,
  getMyCourses,
  getMyCertificates
}
